import Accordion from "./components/Accordion"
import ListToggler from "./components/ListToggler"
import MainMenuNav from "./main-nav.js"
import documentHeight from "./components/documentHeight"

// Functionality applied to all pages.
$(document).ready(function () {
  // Load fix for mobile height
  documentHeight()

  // Create a namespace.
  window.SOMAR = window.SOMAR || {}

  new window.SOMAR.ScrollToTop()

  window.SOMAR.toggleNewLetter()

  new Accordion()
  new ListToggler()
  new MainMenuNav()
})

// Tables
;(function () {
  $(".typography table:not(.no-scroll)").each(function (index) {
    var table = $(this)
    table.wrap("<div class='table-scroll'></div>")

    table
      .find("th")
      .filter(function (index) {
        return $(this).next("td").length
      })
      .addClass("followed-by-td")
  })

  $('iframe:not(.sr-only)').each(function (i, e) {
    const iframe = $(this)
    if (iframe.parent().is('p')) {
      iframe.parent().addClass('iframe-holder')
    } else {
      iframe.wrap('<div class="iframe-holder"></div>')
    }
  })

  var setTableWidth = function () {
    $(".typography table:not(.no-scroll)").each(function(i, el) {
      const width = el.style ? el.style.width : null
      $(this).css("min-width", width ?? $(this).outerWidth())
    })
  }

  var setLeftColumnWidth = function () {
    var leftColumnWidth = "auto"
    if ($(window).width() < 992) {
      var calcWidth = Math.floor($(window).width() / 7)
      // minimum width
      if (calcWidth < 90) {
        calcWidth = 90
      }
      leftColumnWidth = calcWidth + "px"
    } else {
      leftColumnWidth = "auto"
    }
    $(".typography table th:first-child").css("max-width", leftColumnWidth)
  }

  setTableWidth()
  setLeftColumnWidth()
  $(window).resize(function () {
    setLeftColumnWidth()
  })
})()

// Scroll to top
;(function () {
  var ScrollToTop = function () {
    $(".js-back-to-top").each(function () {
      $(this).click(function (e) {
        e.preventDefault()
        $("html,body").animate({ scrollTop: 0 }, "fast")
        return false
      })
    })
  }

  window.SOMAR = window.SOMAR || {}
  window.SOMAR.ScrollToTop = ScrollToTop
})()

// Infinite Scroll
;(function () {
  var InfiniteScroll = function (opts) {
    var defaultOptions = {
      el: ".js-infinite-scroll-container",
      messageEl: ".js-infinite-scroll-message",
      noMoreResultsMessage: "No more results",
      limit: 10,
      maxOffset: null,
    }

    var options = {}

    $.extend(options, defaultOptions, opts)

    if ($(options.el).attr("data-scroll-limit")) {
      options.limit = parseInt($(options.el).attr("data-scroll-limit"))
    }

    if ($(options.el).attr("data-scroll-maxoffset")) {
      options.maxOffset = parseInt($(options.el).attr("data-scroll-maxoffset"))
    }

    if (options.maxOffset === null) {
      throw new Error("maxOffset must be set")
    }

    if (options.load && typeof options.load !== "function") {
      throw new Error("load must be a function")
    }

    if (!options.load) {
      if ($(options.el).attr("data-scroll-url")) {
        options.url = $(options.el).attr("data-scroll-url")
      } else {
        throw new Error("url must be set")
      }
    }

    if (options.maxOffset <= 10) {
      $(".loading-element__wrapper").hide()
    }

    var infiniteScroll = {
      options: options,
    }

    infiniteScroll.init = function () {
      this.currentOffset = 0

      if (this.options.maxOffset > 10) {
        this.bindEvents()
      }
    }

    infiniteScroll.bindEvents = function () {
      var that = this

      $(window).on("scroll", _.debounce(that.scrollEvent, 500))
    }

    infiniteScroll.scrollEvent = function (ev) {
      var $loadingEl = $(".loading-element__wrapper")

      if ($(window).scrollTop() + $(window).height() >= $(document).height() - 500) {
        $(infiniteScroll.options.el).trigger("infinite-scroll-before-load", [ev, infiniteScroll])

        $loadingEl.show()

        if (infiniteScroll.options.load) {
          infiniteScroll.options.load(
            infiniteScroll.options.limit,
            infiniteScroll.currentOffset,
            infiniteScroll.options.maxOffset,
            $(infiniteScroll.options.el)
          )
        } else {
          if (infiniteScroll.currentOffset < infiniteScroll.options.maxOffset) {
            $.get(
              infiniteScroll.options.url,
              {
                limit: infiniteScroll.options.limit,
                offset: infiniteScroll.currentOffset + infiniteScroll.options.limit,
              },
              function (data) {
                $(infiniteScroll.options.el).append(data)

                $loadingEl.hide()
              }
            )
          }
        }

        infiniteScroll.currentOffset = infiniteScroll.currentOffset + infiniteScroll.options.limit

        $(infiniteScroll.options.el).trigger("infinite-scroll-after-load", [ev, infiniteScroll])

        if (infiniteScroll.currentOffset > infiniteScroll.options.maxOffset) {
          $(".loading-element__wrapper").hide()

          if ($(infiniteScroll.options.messageEl).text() !== infiniteScroll.options.noMoreResultsMessage) {
            $(infiniteScroll.options.messageEl).text(infiniteScroll.options.noMoreResultsMessage)
          }
        }
      }
    }

    infiniteScroll.init()

    return infiniteScroll
  }

  window.SOMAR = window.SOMAR || {}
  window.SOMAR.InfiniteScroll = InfiniteScroll
})()

// Footer toggle news letter subscription
;(function () {
  var toggleNewLetter = function () {
    var $link = $(".js-toggle-news-letter-link")
    var $form = $(".js-toggle-news-letter-form")
    var $iconExpanded = $(".js-toggle-news-letter-icon-expanded")
    var $iconCollapsed = $(".js-toggle-news-letter-icon-collapsed")

    $link.click(function (e) {
      e.preventDefault()
      if ($form.hasClass("newsletter-epxanded")) {
        $iconExpanded.hide()
        $iconCollapsed.show()
        $form.removeClass("newsletter-epxanded")
      } else {
        $iconExpanded.show()
        $iconCollapsed.hide()
        $form.addClass("newsletter-epxanded")
      }
    })
  }

  window.SOMAR = window.SOMAR || {}
  window.SOMAR.toggleNewLetter = toggleNewLetter
})()

// Competition form
$(function () {
  const $form = $(".competitionform")
  const $type = $form.find(".js-type input")
  const $image = $form.find(".js-image")
  const $story = $form.find(".js-story")

  function togglePhoto() {
    $image.show().find("input").prop("required", true)
    $story.hide().find("textarea").prop("required", false)
  }

  function toggleStory() {
    $image.hide().find("input").prop("required", false)
    $story.show().find("textarea").prop("required", true)
  }

  function switchType() {
    const type = $type.filter(":checked").val()

    if (type !== "Story") {
      togglePhoto()
    } else {
      toggleStory()
    }
  }

  function updateCharacterLimit() {
    const $input = $story.find("textarea")
    const $label = $story.find("label.right")
    const limit = parseInt($input.attr("maxlength"), 10)
    const count = $input.val().length

    $label.text(limit - count + " characters left")

    if (count === limit) {
      return false
    }

    return true
  }

  if ($form.length) {
    $form.find("[required]").each(function () {
      $(this).closest("div.field").addClass("field-required")
    })

    switchType.call()
    $type.on("change", switchType)

    updateCharacterLimit.call()
    $story.find("textarea").on("keyup", updateCharacterLimit)
  }
})

// Register form
$(function () {
  const $form = $(".registerform")

  if ($form.length) {
    $form.find("[required]").each(function () {
      $(this).closest("div.field").addClass("field-required")
    })
  }
})
